import axios from 'axios';
import Cookies from "universal-cookie";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function getToken() {
  const cookies = new Cookies();
  const token = cookies.get("token");
  
  // Note: Laravel Sanctum tokens are not JWTs, so we skip format validation
  // Basic XSS protection only
  if (token && (token.includes('<script') || token.includes('javascript:'))) {
    console.warn('Suspicious token content detected, removing token');
    return null;
  }
  
  return token;
}

/**
 * Get all research hypotheses for a project
 */
export const getResearchHypotheses = async (projectUuid) => {
    try {
        const response = await axios.get(`${API_BASE}/project/${projectUuid}/research-hypotheses`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Create a manual research hypothesis
 */
export const createResearchHypothesis = async (projectUuid, hypothesisData) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-hypotheses`, hypothesisData, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Update a research hypothesis
 */
export const updateResearchHypothesis = async (projectUuid, hypothesisUuid, hypothesisData) => {
    try {
        const response = await axios.put(`${API_BASE}/project/${projectUuid}/research-hypotheses/${hypothesisUuid}`, hypothesisData, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Delete a research hypothesis
 */
export const deleteResearchHypothesis = async (projectUuid, hypothesisUuid) => {
    try {
        const response = await axios.delete(`${API_BASE}/project/${projectUuid}/research-hypotheses/${hypothesisUuid}`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Generate AI suggestions for research hypotheses
 */
export const generateHypothesisAISuggestions = async (projectUuid, scope, hypothesisType, formResponses) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-hypotheses/generate-ai`, {
            scope: scope,
            hypothesis_type: hypothesisType,
            form_responses: formResponses
        }, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Select/activate a research hypothesis (deactivating others)
 */
export const selectResearchHypothesis = async (projectUuid, hypothesisUuid) => {
    try {
        const response = await axios.post(`${API_BASE}/project/${projectUuid}/research-hypotheses/${hypothesisUuid}/select`, {}, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

/**
 * Get form questions for hypotheses based on scope and type
 */
export const getHypothesisFormQuestions = async (scope = 'academic', hypothesisType = 'general') => {
    try {
        const response = await axios.get(`${API_BASE}/research-hypotheses/form-questions/${scope}/${hypothesisType}`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};